export const bloodShadow = {
  textShadow: `
    1.75px 1px 0 #630202,
   -1.75px -1px 0 #630202,
    1.75px -1px 0 #630202,
   -1.75px 1px 0 #630202
  `,
}

export const subtitleShadow = {
  textShadow: '0px 2.29px 2.29px rgba(0, 0, 0, 0.25)',
}

export const tableTypoBase = {
  textTransform: 'uppercase',
  fontWeight: 700,
  padding: '8px',
  background: 'transparents',
} as const

export const tableTypoShawdow = {
  WebkitTextStroke: '1.24px  #FF0000',
  WebkitTextFillColor: '#fff',
  color: '#fff',
}

export const tableTypoShawdowV2 = {
  letterSpacing: '0.05em',
  textShadow: `
  -2px -2px 1px red,
   0px -2px 1px red,
   2px -2px 1px red,
  -2px  0px 1px red,
   2px  0px 1px red,
  -2px  2px 1px red,
   0px  2px 1px red,
   2px  2px 1px red,
  -1px -1px 1px red,
   1px -1px 1px red,
  -1px  1px 1px red,
   1px  1px 1px red
`,
}
